import {
    Alert,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    Typography,
  } from '@mui/material';
  import React, { useCallback, useState } from 'react';
  import { convertToAutoSuggestion } from '../../api/products';
  import MoveDownIcon from '@mui/icons-material/MoveDown';
  import useAuthToken from '../../hooks/getUserData';
  
  export default function ConvertToAutoSuggestion({
    product,
    fetchData,
    setMessage,
    setSnackbarOpen,
  }) {
    const [error, setError] = useState(null);
    const [confirmationOpen, setConfirmationOpen] = useState(false);
    const token = useAuthToken();
  
    const handleConvert = useCallback(async () => {
      try {
        const response = await convertToAutoSuggestion(product.id, token);
        if (response.ok) {
          setSnackbarOpen(true);
          setMessage('Product converted to auto-suggestion successfully');
          fetchData();
        } else {
          setError('Failed to convert product. Please try again.');
        }
      } catch (err) {
        setError('Failed to convert product. Please try again.');
      }
    }, [product, fetchData, token, setMessage, setSnackbarOpen]);
  
    const handleConvertButtonClick = () => {
      setError(null);
      setConfirmationOpen(true);
    };
  
    const handleConvertConfirm = () => {
      handleConvert();
      setConfirmationOpen(false);
    };
  
    const handleConvertCancel = () => {
      setError(null);
      setConfirmationOpen(false);
    };
  
    return (
      <>
        <IconButton
          title="Convert to auto-suggestion"
          size="small"
          sx={{ p: 2 }}
          onClick={handleConvertButtonClick}>
          <MoveDownIcon />
        </IconButton>
        <Dialog
          open={confirmationOpen}
          onClose={handleConvertCancel}
          fullWidth
          maxWidth="sm">
          <DialogTitle>Confirmation</DialogTitle>
          <DialogContent>
            {error && (
              <Alert severity="error" sx={{ mb: 2 }}>
                {error}
              </Alert>
            )}
            <Typography>
              Are you sure you want to convert <strong>{product?.title}</strong> to
              auto-suggestion products?
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleConvertCancel} color="primary">
              Cancel
            </Button>
            <Button onClick={handleConvertConfirm} color="secondary">
              Convert
            </Button>
          </DialogActions>
        </Dialog>
      </>
    );
  }